<template>
	<Modal>
		<h1 class="text-center">
			<small>Welcome to</small>
			<br>
			Heart Hunter,
		</h1>
		<h2 class="text-center animated bounceInUp delay-1s font-weight-bold position-absolute">The game you always wanted to win!</h2>
		<hr class="mb-5">
		<p class="text-center"><strong>Current settings:</strong></p>
		<p
			class="text-center"
			v-if="settings"
		>
			{{ mode }}<br>
			On a {{ settings.width }}x{{ settings.height }} board,
			with a captive limit of {{ settings.limit }}
		</p>
		<template v-slot:footer>
			<button
				class="btn btn-light"
				@click="$emit('settings')"
			>Settings</button>
			<button
				class="btn btn-light"
				@click="$emit('rules')"
			>Rules</button>
			<button
				class="btn btn-success"
				@click="$emit('start')"
			>New game</button>
			<div class="mt-3 small text-center">
				<a href="javascript:void(0)" @click="$emit('privacy')">Privacy policy</a>
				| Contact:
				<a href="mailto:info@hearthunter-game.com">info@hearthunter-game.com</a>
			</div>
		</template>
	</Modal>
</template>

<script>
export default {
	props: ["settings"],
	computed: {
		mode() {
			const t = {
				"H-M": "Against computer, you start",
				"M-H": "Against computer, computer starts",
				"H-H": "Multiplayer (not yet implemented)",
				TABLET: "Local multiplayer"
			};
			return t[this.settings.mode].replace(
				"computer",
				`${this.settings.level.replace(/_/, " ")} computer`
			);
		}
	}
};
</script>

<style lang="scss">
@import "@/scss/variables.scss";

h2 + hr {
	margin-top: 4rem;
}

h2 {
	color: $red;
	left: 0;
	width: 100%;
}
</style>